
import React, { useCallback, useEffect, useState } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { getStatus } from '../../helperFunction/status';

function TaskStatus({ status, data }) {
  // console.log('winne', status, data);
  const [curruntStatus, setCurruntStatus] = useState();
// Only re-run when data.contractTaskId changes


  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" className="tolltipssss" {...props}>
      {curruntStatus?.tooltipData}
    </Tooltip>
  );
  function formatStatus(status) {
    // Separate camelCase words and capitalize the first letter of each word
    const formatted = status?.replace(/([a-z])([A-Z])/g, '$1 $2')  // Adds space between camelCase words
      .split(' ')  // Split into words
      .map(word => word?.charAt(0)?.toUpperCase() + word?.slice(1))  // Capitalize first letter
      .join(' ');  // Join the words back together

    return formatted;
  }
  // useEffect(() => {
  //   if (data) {
  //     const taskData = {
  //       ...data.task,
  //       // isClaimed: data.isClaimed,
  //       // outerStatus: data.status,
  //     };
  //     const status = getStatus(taskData, 'taskCreated');
  //     setCurruntStatus(status);
  //     console.log(status, 'yyyyyyyyyy');
  //   }
  // }, [data]);
  useEffect(() => {
    if (data) {
      if (data?.status === 'completed') {
        data.isClaimed = true
      } else {
        data.isClaimed = false
      }

      const status = getStatus(data, 'taskCreated');
      setCurruntStatus(status);
      // console.log(status, 'statusstatusstatus');
    }
  }, [data])

  return (
    <p className="tablepara">
      <button className={curruntStatus?.classname}>
        {" "}
        {formatStatus(curruntStatus?.status)}
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
          >
            <path
              d="M6 1.125C5.03582 1.125 4.09329 1.41091 3.2916 1.94659C2.48991 2.48226 1.86507 3.24363 1.49609 4.13442C1.12711 5.02521 1.03057 6.00541 1.21867 6.95107C1.40678 7.89672 1.87108 8.76537 2.55286 9.44715C3.23464 10.1289 4.10328 10.5932 5.04894 10.7813C5.99459 10.9694 6.97479 10.8729 7.86558 10.5039C8.75637 10.1349 9.51775 9.51009 10.0534 8.70841C10.5891 7.90672 10.875 6.96418 10.875 6C10.8736 4.70749 10.3596 3.46831 9.44564 2.55436C8.5317 1.64042 7.29251 1.12636 6 1.125ZM5.8125 3.375C5.92375 3.375 6.03251 3.40799 6.12501 3.4698C6.21751 3.53161 6.28961 3.61946 6.33218 3.72224C6.37476 3.82502 6.3859 3.93812 6.36419 4.04724C6.34249 4.15635 6.28892 4.25658 6.21025 4.33525C6.13158 4.41391 6.03136 4.46749 5.92224 4.48919C5.81313 4.5109 5.70003 4.49976 5.59724 4.45718C5.49446 4.41461 5.40661 4.34251 5.3448 4.25001C5.28299 4.15751 5.25 4.04875 5.25 3.9375C5.25 3.78832 5.30927 3.64524 5.41475 3.53975C5.52024 3.43426 5.66332 3.375 5.8125 3.375ZM6.375 8.625C6.17609 8.625 5.98532 8.54598 5.84467 8.40533C5.70402 8.26468 5.625 8.07391 5.625 7.875V6C5.52555 6 5.43016 5.96049 5.35984 5.89017C5.28951 5.81984 5.25 5.72446 5.25 5.625C5.25 5.52554 5.28951 5.43016 5.35984 5.35984C5.43016 5.28951 5.52555 5.25 5.625 5.25C5.82392 5.25 6.01468 5.32902 6.15533 5.46967C6.29598 5.61032 6.375 5.80109 6.375 6V7.875C6.47446 7.875 6.56984 7.91451 6.64017 7.98484C6.71049 8.05516 6.75 8.15054 6.75 8.25C6.75 8.34946 6.71049 8.44484 6.64017 8.51517C6.56984 8.58549 6.47446 8.625 6.375 8.625Z"
              fill={curruntStatus?.tooltipColor}
            />
          </svg>
        </OverlayTrigger>{" "}
      </button>
    </p>
  )
}

export default TaskStatus

// import React from "react";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";
// function TaskStatus({ status, data }) {
//   // Logic for determining the class name based on the status
//   // const getStatusClass = (status) => {
//   //     let endTime = new Date(data?.endTime); //"2024-11-14T07:09:00.000Z"
//   //     let currentTime = new Date();
//   //     let reviewTimePeriod = new Date(data?.reviewTimePeriod);
//   //     let coolDownPeriod = new Date(data?.coolDownPeriod);

//   //     let votingEndPeriod = new Date(data?.votingEndPeriod);
//   //     if (data?.status === 'inProgress' && currentTime < endTime) {
//   //         return 'Live'
//   //     } else if (currentTime > endTime && currentTime < reviewTimePeriod && reviewTimePeriod < coolDownPeriod) {
//   //         return 'Under Review'
//   //     } else if (currentTime > endTime && currentTime < reviewTimePeriod && reviewTimePeriod < coolDownPeriod && status === 'winner') {
//   //         return 'Winner Selected'
//   //     } else if (currentTime > endTime && currentTime > reviewTimePeriod && currentTime < coolDownPeriod && status === 'inDispute') {
//   //         return 'In Voting Period'
//   //     } else if (currentTime > endTime && currentTime > reviewTimePeriod && currentTime < coolDownPeriod) {
//   //         return 'In Dispute Period'
//   //     }
//   //     // } else if (data?.status === 'winner' && data?.isClaimed === false && currentTime < coolDownPeriod) {
//   //     //     return '/assets/createtask/inDisputePeriod.svg'
//   //     // } else if ( currentTime > coolDownPeriod && data?.status === 'winner' && data?.isClaimed === false ) {
//   //     //     return '/assets/createtask/winnerSelected.svg'
//   //     // } if (data?.status === 'winner' && data?.isClaimed === true) {
//   //     //     return '/assets/createtask/completed.svg'
//   //     // }
//   //     else {
//   //         return 'Completed'
//   //     }
//   // };
//   const getStatusClass = (status) => {
//     console.log("Data in task created : ", data);
//     let endTime = new Date(data?.endTime); //"2024-11-14T07:09:00.000Z"
//     let currentTime = new Date();
//     let reviewTimePeriod = new Date(data?.reviewTimePeriod);
//     let coolDownPeriod = new Date(data?.coolDownPeriod);

//     let votingEndPeriod = new Date(data?.votingEndPeriod);
//     if (data?.status === "inProgress" && currentTime < endTime) {
//       return "Live";
//     } else if (
//       currentTime > endTime &&
//       currentTime < reviewTimePeriod &&
//       reviewTimePeriod < coolDownPeriod
//     ) {
//       return "In Review Period";
//     } else if (
//       currentTime > endTime &&
//       currentTime < reviewTimePeriod &&
//       status === "winner"
//     ) {
//       return "Winner Selected";
//     }
//     // else if (currentTime > endTime && currentTime > reviewTimePeriod && currentTime < coolDownPeriod && status === 'inDispute') {
//     //     return 'In Voting Period'
//     // } else if (currentTime > endTime && currentTime > reviewTimePeriod && currentTime < coolDownPeriod) {
//     //     return 'In Dispute Period'
//     // }
//     // } else if (data?.status === 'winner' && data?.isClaimed === false && currentTime < coolDownPeriod) {
//     //     return '/assets/createtask/inDisputePeriod.svg'
//     // } else if ( currentTime > coolDownPeriod && data?.status === 'winner' && data?.isClaimed === false ) {
//     //     return '/assets/createtask/winnerSelected.svg'
//     // } if (data?.status === 'winner' && data?.isClaimed === true) {
//     //     return '/assets/createtask/completed.svg'
//     // }
//     else {
//       return "Completed";
//     }
//   };
//   const renderTooltip1 = (props) => (
//     <Tooltip id="button-tooltip" className="tolltipssss" {...props}>
//       The task is active on the website and accepting participants. The due date
//       has not yet passed.
//     </Tooltip>
//   );

//   const renderTooltipInDispute = (props) => (
//     <Tooltip id="button-tooltip" className="tolltipssss" {...props}>
//       The task is currently in dispute. The outcome is under review.
//     </Tooltip>
//   );

//   const renderTooltipInVoting = (props) => (
//     <Tooltip id="button-tooltip" className="tolltipssss" {...props}>
//       The task is in the voting period. Participants are casting their votes.
//     </Tooltip>
//   );

//   const renderTooltipWinnerDetermined = (props) => (
//     <Tooltip id="button-tooltip" className="tolltipssss" {...props}>
//       The winner has been determined. The task outcome is final.
//     </Tooltip>
//   );

//   const renderTooltipCompleted = (props) => (
//     <Tooltip id="button-tooltip" className="tolltipssss" {...props}>
//       The task has been completed. No further actions are required.
//     </Tooltip>
//   );

//   const renderTooltipUnderReview = (props) => (
//     <Tooltip id="button-tooltip" className="tolltipssss" {...props}>
//       The task is under review. Awaiting final evaluation.
//     </Tooltip>
//   );

//   return (
//     <p className="tablepara">
//       {/* <span className={getStatusClass(status)}>{status}</span> */}
//       {/* <img src={getStatusClass(status)} alt="" srcset="" /> */}
//       {getStatusClass(status) === "Winner Selected" && (
//         <button className="winnerSelected">
//           {" "}
//           {getStatusClass(status)}{" "}
//           <OverlayTrigger
//             placement="bottom"
//             delay={{ show: 250, hide: 400 }}
//             overlay={renderTooltipWinnerDetermined}
//           >
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               width="12"
//               height="12"
//               viewBox="0 0 12 12"
//               fill="none"
//             >
//               <path
//                 d="M6 1.125C5.03582 1.125 4.09329 1.41091 3.2916 1.94659C2.48991 2.48226 1.86507 3.24363 1.49609 4.13442C1.12711 5.02521 1.03057 6.00541 1.21867 6.95107C1.40678 7.89672 1.87108 8.76537 2.55286 9.44715C3.23464 10.1289 4.10328 10.5932 5.04894 10.7813C5.99459 10.9694 6.97479 10.8729 7.86558 10.5039C8.75637 10.1349 9.51775 9.51009 10.0534 8.70841C10.5891 7.90672 10.875 6.96418 10.875 6C10.8736 4.70749 10.3596 3.46831 9.44564 2.55436C8.5317 1.64042 7.29251 1.12636 6 1.125ZM5.8125 3.375C5.92375 3.375 6.03251 3.40799 6.12501 3.4698C6.21751 3.53161 6.28961 3.61946 6.33218 3.72224C6.37476 3.82502 6.3859 3.93812 6.36419 4.04724C6.34249 4.15635 6.28892 4.25658 6.21025 4.33525C6.13158 4.41391 6.03136 4.46749 5.92224 4.48919C5.81313 4.5109 5.70003 4.49976 5.59724 4.45718C5.49446 4.41461 5.40661 4.34251 5.3448 4.25001C5.28299 4.15751 5.25 4.04875 5.25 3.9375C5.25 3.78832 5.30927 3.64524 5.41475 3.53975C5.52024 3.43426 5.66332 3.375 5.8125 3.375ZM6.375 8.625C6.17609 8.625 5.98532 8.54598 5.84467 8.40533C5.70402 8.26468 5.625 8.07391 5.625 7.875V6C5.52555 6 5.43016 5.96049 5.35984 5.89017C5.28951 5.81984 5.25 5.72446 5.25 5.625C5.25 5.52554 5.28951 5.43016 5.35984 5.35984C5.43016 5.28951 5.52555 5.25 5.625 5.25C5.82392 5.25 6.01468 5.32902 6.15533 5.46967C6.29598 5.61032 6.375 5.80109 6.375 6V7.875C6.47446 7.875 6.56984 7.91451 6.64017 7.98484C6.71049 8.05516 6.75 8.15054 6.75 8.25C6.75 8.34946 6.71049 8.44484 6.64017 8.51517C6.56984 8.58549 6.47446 8.625 6.375 8.625Z"
//                 fill="#FF0083"
//               />
//             </svg>
//           </OverlayTrigger>{" "}
//         </button>
//       )}
//       {getStatusClass(status) === "Live" && (
//         <button className="greenbuttontoltip">
//           {" "}
//           {getStatusClass(status)}{" "}
//           <OverlayTrigger
//             placement="bottom"
//             delay={{ show: 250, hide: 400 }}
//             overlay={renderTooltip1}
//           >
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               width="12"
//               height="12"
//               viewBox="0 0 12 12"
//               fill="none"
//             >
//               <path
//                 d="M6 1.125C5.03582 1.125 4.09329 1.41091 3.2916 1.94659C2.48991 2.48226 1.86507 3.24363 1.49609 4.13442C1.12711 5.02521 1.03057 6.00541 1.21867 6.95107C1.40678 7.89672 1.87108 8.76537 2.55286 9.44715C3.23464 10.1289 4.10328 10.5932 5.04894 10.7813C5.99459 10.9694 6.97479 10.8729 7.86558 10.5039C8.75637 10.1349 9.51775 9.51009 10.0534 8.70841C10.5891 7.90672 10.875 6.96418 10.875 6C10.8736 4.70749 10.3596 3.46831 9.44564 2.55436C8.5317 1.64042 7.29251 1.12636 6 1.125ZM5.8125 3.375C5.92375 3.375 6.03251 3.40799 6.12501 3.4698C6.21751 3.53161 6.28961 3.61946 6.33218 3.72224C6.37476 3.82502 6.3859 3.93812 6.36419 4.04724C6.34249 4.15635 6.28892 4.25658 6.21025 4.33525C6.13158 4.41391 6.03136 4.46749 5.92224 4.48919C5.81313 4.5109 5.70003 4.49976 5.59724 4.45718C5.49446 4.41461 5.40661 4.34251 5.3448 4.25001C5.28299 4.15751 5.25 4.04875 5.25 3.9375C5.25 3.78832 5.30927 3.64524 5.41475 3.53975C5.52024 3.43426 5.66332 3.375 5.8125 3.375ZM6.375 8.625C6.17609 8.625 5.98532 8.54598 5.84467 8.40533C5.70402 8.26468 5.625 8.07391 5.625 7.875V6C5.52555 6 5.43016 5.96049 5.35984 5.89017C5.28951 5.81984 5.25 5.72446 5.25 5.625C5.25 5.52554 5.28951 5.43016 5.35984 5.35984C5.43016 5.28951 5.52555 5.25 5.625 5.25C5.82392 5.25 6.01468 5.32902 6.15533 5.46967C6.29598 5.61032 6.375 5.80109 6.375 6V7.875C6.47446 7.875 6.56984 7.91451 6.64017 7.98484C6.71049 8.05516 6.75 8.15054 6.75 8.25C6.75 8.34946 6.71049 8.44484 6.64017 8.51517C6.56984 8.58549 6.47446 8.625 6.375 8.625Z"
//                 fill="#3EDD1E"
//               />
//             </svg>
//           </OverlayTrigger>{" "}
//         </button>
//       )}
//       {getStatusClass(status) === "In Review Period" && (
//         <button className="underReview">
//           {" "}
//           {getStatusClass(status)}{" "}
//           <OverlayTrigger
//             placement="bottom"
//             delay={{ show: 250, hide: 400 }}
//             overlay={renderTooltipUnderReview}
//           >
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               width="12"
//               height="12"
//               viewBox="0 0 12 12"
//               fill="none"
//             >
//               <path
//                 d="M6 1.125C5.03582 1.125 4.09329 1.41091 3.2916 1.94659C2.48991 2.48226 1.86507 3.24363 1.49609 4.13442C1.12711 5.02521 1.03057 6.00541 1.21867 6.95107C1.40678 7.89672 1.87108 8.76537 2.55286 9.44715C3.23464 10.1289 4.10328 10.5932 5.04894 10.7813C5.99459 10.9694 6.97479 10.8729 7.86558 10.5039C8.75637 10.1349 9.51775 9.51009 10.0534 8.70841C10.5891 7.90672 10.875 6.96418 10.875 6C10.8736 4.70749 10.3596 3.46831 9.44564 2.55436C8.5317 1.64042 7.29251 1.12636 6 1.125ZM5.8125 3.375C5.92375 3.375 6.03251 3.40799 6.12501 3.4698C6.21751 3.53161 6.28961 3.61946 6.33218 3.72224C6.37476 3.82502 6.3859 3.93812 6.36419 4.04724C6.34249 4.15635 6.28892 4.25658 6.21025 4.33525C6.13158 4.41391 6.03136 4.46749 5.92224 4.48919C5.81313 4.5109 5.70003 4.49976 5.59724 4.45718C5.49446 4.41461 5.40661 4.34251 5.3448 4.25001C5.28299 4.15751 5.25 4.04875 5.25 3.9375C5.25 3.78832 5.30927 3.64524 5.41475 3.53975C5.52024 3.43426 5.66332 3.375 5.8125 3.375ZM6.375 8.625C6.17609 8.625 5.98532 8.54598 5.84467 8.40533C5.70402 8.26468 5.625 8.07391 5.625 7.875V6C5.52555 6 5.43016 5.96049 5.35984 5.89017C5.28951 5.81984 5.25 5.72446 5.25 5.625C5.25 5.52554 5.28951 5.43016 5.35984 5.35984C5.43016 5.28951 5.52555 5.25 5.625 5.25C5.82392 5.25 6.01468 5.32902 6.15533 5.46967C6.29598 5.61032 6.375 5.80109 6.375 6V7.875C6.47446 7.875 6.56984 7.91451 6.64017 7.98484C6.71049 8.05516 6.75 8.15054 6.75 8.25C6.75 8.34946 6.71049 8.44484 6.64017 8.51517C6.56984 8.58549 6.47446 8.625 6.375 8.625Z"
//                 fill="#4987E4"
//               />
//             </svg>
//           </OverlayTrigger>{" "}
//         </button>
//       )}
//       {getStatusClass(status) === "In Voting Period" && (
//         <button className="lightbuttontoltip">
//           {" "}
//           {getStatusClass(status)}{" "}
//           <OverlayTrigger
//             placement="bottom"
//             delay={{ show: 250, hide: 400 }}
//             overlay={renderTooltipInVoting}
//           >
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               width="12"
//               height="12"
//               viewBox="0 0 12 12"
//               fill="none"
//             >
//               <path
//                 d="M6 1.125C5.03582 1.125 4.09329 1.41091 3.2916 1.94659C2.48991 2.48226 1.86507 3.24363 1.49609 4.13442C1.12711 5.02521 1.03057 6.00541 1.21867 6.95107C1.40678 7.89672 1.87108 8.76537 2.55286 9.44715C3.23464 10.1289 4.10328 10.5932 5.04894 10.7813C5.99459 10.9694 6.97479 10.8729 7.86558 10.5039C8.75637 10.1349 9.51775 9.51009 10.0534 8.70841C10.5891 7.90672 10.875 6.96418 10.875 6C10.8736 4.70749 10.3596 3.46831 9.44564 2.55436C8.5317 1.64042 7.29251 1.12636 6 1.125ZM5.8125 3.375C5.92375 3.375 6.03251 3.40799 6.12501 3.4698C6.21751 3.53161 6.28961 3.61946 6.33218 3.72224C6.37476 3.82502 6.3859 3.93812 6.36419 4.04724C6.34249 4.15635 6.28892 4.25658 6.21025 4.33525C6.13158 4.41391 6.03136 4.46749 5.92224 4.48919C5.81313 4.5109 5.70003 4.49976 5.59724 4.45718C5.49446 4.41461 5.40661 4.34251 5.3448 4.25001C5.28299 4.15751 5.25 4.04875 5.25 3.9375C5.25 3.78832 5.30927 3.64524 5.41475 3.53975C5.52024 3.43426 5.66332 3.375 5.8125 3.375ZM6.375 8.625C6.17609 8.625 5.98532 8.54598 5.84467 8.40533C5.70402 8.26468 5.625 8.07391 5.625 7.875V6C5.52555 6 5.43016 5.96049 5.35984 5.89017C5.28951 5.81984 5.25 5.72446 5.25 5.625C5.25 5.52554 5.28951 5.43016 5.35984 5.35984C5.43016 5.28951 5.52555 5.25 5.625 5.25C5.82392 5.25 6.01468 5.32902 6.15533 5.46967C6.29598 5.61032 6.375 5.80109 6.375 6V7.875C6.47446 7.875 6.56984 7.91451 6.64017 7.98484C6.71049 8.05516 6.75 8.15054 6.75 8.25C6.75 8.34946 6.71049 8.44484 6.64017 8.51517C6.56984 8.58549 6.47446 8.625 6.375 8.625Z"
//                 fill="#E2C624"
//               />
//             </svg>
//           </OverlayTrigger>{" "}
//         </button>
//       )}
//       {getStatusClass(status) === "In Dispute Period" && (
//         <button className="orangebuttontoltip">
//           {" "}
//           {getStatusClass(status)}{" "}
//           <OverlayTrigger
//             placement="bottom"
//             delay={{ show: 250, hide: 400 }}
//             overlay={renderTooltipInDispute}
//           >
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               width="12"
//               height="12"
//               viewBox="0 0 12 12"
//               fill="none"
//             >
//               <path
//                 d="M6 1.125C5.03582 1.125 4.09329 1.41091 3.2916 1.94659C2.48991 2.48226 1.86507 3.24363 1.49609 4.13442C1.12711 5.02521 1.03057 6.00541 1.21867 6.95107C1.40678 7.89672 1.87108 8.76537 2.55286 9.44715C3.23464 10.1289 4.10328 10.5932 5.04894 10.7813C5.99459 10.9694 6.97479 10.8729 7.86558 10.5039C8.75637 10.1349 9.51775 9.51009 10.0534 8.70841C10.5891 7.90672 10.875 6.96418 10.875 6C10.8736 4.70749 10.3596 3.46831 9.44564 2.55436C8.5317 1.64042 7.29251 1.12636 6 1.125ZM5.8125 3.375C5.92375 3.375 6.03251 3.40799 6.12501 3.4698C6.21751 3.53161 6.28961 3.61946 6.33218 3.72224C6.37476 3.82502 6.3859 3.93812 6.36419 4.04724C6.34249 4.15635 6.28892 4.25658 6.21025 4.33525C6.13158 4.41391 6.03136 4.46749 5.92224 4.48919C5.81313 4.5109 5.70003 4.49976 5.59724 4.45718C5.49446 4.41461 5.40661 4.34251 5.3448 4.25001C5.28299 4.15751 5.25 4.04875 5.25 3.9375C5.25 3.78832 5.30927 3.64524 5.41475 3.53975C5.52024 3.43426 5.66332 3.375 5.8125 3.375ZM6.375 8.625C6.17609 8.625 5.98532 8.54598 5.84467 8.40533C5.70402 8.26468 5.625 8.07391 5.625 7.875V6C5.52555 6 5.43016 5.96049 5.35984 5.89017C5.28951 5.81984 5.25 5.72446 5.25 5.625C5.25 5.52554 5.28951 5.43016 5.35984 5.35984C5.43016 5.28951 5.52555 5.25 5.625 5.25C5.82392 5.25 6.01468 5.32902 6.15533 5.46967C6.29598 5.61032 6.375 5.80109 6.375 6V7.875C6.47446 7.875 6.56984 7.91451 6.64017 7.98484C6.71049 8.05516 6.75 8.15054 6.75 8.25C6.75 8.34946 6.71049 8.44484 6.64017 8.51517C6.56984 8.58549 6.47446 8.625 6.375 8.625Z"
//                 fill="#FF9500"
//               />
//             </svg>
//           </OverlayTrigger>{" "}
//         </button>
//       )}
//       {getStatusClass(status) === "Completed" && (
//         <button className="completed">
//           {" "}
//           {getStatusClass(status)}{" "}
//           <OverlayTrigger
//             placement="bottom"
//             delay={{ show: 250, hide: 400 }}
//             overlay={renderTooltipCompleted}
//           >
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               width="12"
//               height="12"
//               viewBox="0 0 12 12"
//               fill="none"
//             >
//               <path
//                 d="M6 1.125C5.03582 1.125 4.09329 1.41091 3.2916 1.94659C2.48991 2.48226 1.86507 3.24363 1.49609 4.13442C1.12711 5.02521 1.03057 6.00541 1.21867 6.95107C1.40678 7.89672 1.87108 8.76537 2.55286 9.44715C3.23464 10.1289 4.10328 10.5932 5.04894 10.7813C5.99459 10.9694 6.97479 10.8729 7.86558 10.5039C8.75637 10.1349 9.51775 9.51009 10.0534 8.70841C10.5891 7.90672 10.875 6.96418 10.875 6C10.8736 4.70749 10.3596 3.46831 9.44564 2.55436C8.5317 1.64042 7.29251 1.12636 6 1.125ZM5.8125 3.375C5.92375 3.375 6.03251 3.40799 6.12501 3.4698C6.21751 3.53161 6.28961 3.61946 6.33218 3.72224C6.37476 3.82502 6.3859 3.93812 6.36419 4.04724C6.34249 4.15635 6.28892 4.25658 6.21025 4.33525C6.13158 4.41391 6.03136 4.46749 5.92224 4.48919C5.81313 4.5109 5.70003 4.49976 5.59724 4.45718C5.49446 4.41461 5.40661 4.34251 5.3448 4.25001C5.28299 4.15751 5.25 4.04875 5.25 3.9375C5.25 3.78832 5.30927 3.64524 5.41475 3.53975C5.52024 3.43426 5.66332 3.375 5.8125 3.375ZM6.375 8.625C6.17609 8.625 5.98532 8.54598 5.84467 8.40533C5.70402 8.26468 5.625 8.07391 5.625 7.875V6C5.52555 6 5.43016 5.96049 5.35984 5.89017C5.28951 5.81984 5.25 5.72446 5.25 5.625C5.25 5.52554 5.28951 5.43016 5.35984 5.35984C5.43016 5.28951 5.52555 5.25 5.625 5.25C5.82392 5.25 6.01468 5.32902 6.15533 5.46967C6.29598 5.61032 6.375 5.80109 6.375 6V7.875C6.47446 7.875 6.56984 7.91451 6.64017 7.98484C6.71049 8.05516 6.75 8.15054 6.75 8.25C6.75 8.34946 6.71049 8.44484 6.64017 8.51517C6.56984 8.58549 6.47446 8.625 6.375 8.625Z"
//                 fill="#7B808A"
//               />
//             </svg>
//           </OverlayTrigger>{" "}
//         </button>
//       )}
//     </p>
//   );
// }

// export default TaskStatus;

// // live = inprogress
// // underreview = endtime khtam or now reviewTimePeriod
// // winner determined = in reviewtime agr winner sslect ho gya ha to
// // indispute = cooldown period
// // In Voting Period = cooldown period ma dispute crate ho ga,  or status of api will be 'indispute'
// // import React from 'react'

// // function TaskStatus({status}) {
// //   return (
// //       <p className="tablepara"><span className={status == "submitted" || status == "pending" ? "progressbtn" : status == "ended" ? "endedbtn" : status == "winner" ? "reviewbtn" : "disputedbtn"}>{status}</span>
// //       </p>
// //   )
// // }

// // export default TaskStatus
